<template>
  <MDropdown ref="dropdownMenu">
    <template v-slot:trigger>
      <MButton
        id="action-btn"
        variant="neutral-lighter"
        class="ml-2"
        :shadow="false"
        shape="circle"
      >
        <MIcon name="ellipsis-v" size="2x" />
      </MButton>
    </template>
    <template v-slot:menu>
      <MMenu class="action-menu">
        <MMenuItem
          v-if="!disabled && purchaseStatus === statusName['generated']"
        >
          <ApprovalAction
            :module-name="moduleName"
            :parent-id="purchase.id"
            :resource-name="purchase.name"
            @trigger="hide"
            @done="$emit('approval-changed')"
          />
        </MMenuItem>
        <MMenuItem
          v-if="!disabled && purchaseStatus === statusName['approved']"
        >
          <OrderPODrawer
            :module-name="moduleName"
            :purchase="purchase"
            @refresh="$emit('refresh')"
            @trigger="hide"
          />
        </MMenuItem>
        <MMenuItem
          v-if="
            !disabled &&
            (purchaseStatus === statusName['ordered'] ||
              purchaseStatus === statusName['partially_received'])
          "
        >
          <ReceiveItemDrawer
            :module-name="moduleName"
            :purchase="purchase"
            :update-api="updateApi"
            :price-custom-fields="priceCustomFields"
            @refresh="$emit('received-item-changed')"
            @trigger="hide"
          />
        </MMenuItem>

        <MMenuItem
          v-if="
            purchaseStatus === statusName['closed'] ||
            purchaseStatus === statusName['cancelled']
          "
        >
          <Archive
            :resource-id="purchase.id"
            :module-name="moduleName"
            @trigger="hide"
            @done="handleArchive"
          />
        </MMenuItem>
        <MMenuItem>
          <Print
            :resource="purchase"
            :module-name="moduleName"
            @trigger="hide"
            @done="hide"
          />
        </MMenuItem>
      </MMenu>
    </template>
  </MDropdown>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import Print from './action-menu-items/print'
import ApprovalAction from '@components/approval/approval-action'
import Archive from './action-menu-items/archive'
import OrderPODrawer from './order-po-drawer'
import ReceiveItemDrawer from './receive-item-drawer'
import { getPurchaseStatusSystemName } from '../helpers/status'
export default {
  name: 'ActionMenu',
  components: {
    Print,
    Archive,
    ApprovalAction,
    OrderPODrawer,
    ReceiveItemDrawer,
  },
  props: {
    moduleName: { type: String, required: true },
    purchase: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    updateApi: { type: Function, default: undefined },
    purchaseStatus: { type: String, default: undefined },
    priceCustomFields: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    this.statusName = getPurchaseStatusSystemName
    return {}
  },
  computed: {
    ...authComputed,
  },
  methods: {
    hide() {
      this.$refs.dropdownMenu.hide()
    },
    handleArchive() {
      this.$emit('archive')
    },
  },
}
</script>
